<template>
  <td v-if="hasContent">
    <span v-if="flagClass" class="flag-icon" :class="flagClass"></span>
    {{ content.ip }}
  </td>
  <td v-else v-html="nullHtml"></td>
</template>

<script>
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
  props: ["content"],
  computed: {
    nullHtml() {
      return defaultNullHtml();
    },
    hasContent() {
      return this.content !== null;
    },
    flagClass() {
      return this.content.country
        ? `flag-icon-${this.content.country.toLowerCase()}`
        : null;
    }
  }
};
</script>
